import { xfetch } from '../../lib/xfetch';
import type { Answer, Question } from '../../survey';
import { getApiBase, REQUEST_TIMEOUT } from '../config';
import { ApiError, ResponseSuccessFieldError, type BaseResponseData } from '../types';
import type { SurveyStatusToSend } from './sendSurveyStatus';

type UserSelectedAnswer = {
  id: Answer['id'];
  answer_date: string; // формат: 2024-12-10T08:24:15.936Z (new Date().toISOString())
};

type UserAnswer = {
  id: Question['id'];
  comment?: string; // коммент юзера к вопросу или ответ на вопрос типа Text
  form_answers: UserSelectedAnswer[];
};

export type UserAnswerToSend = SurveyStatusToSend & {
  form_answer: UserAnswer;
};

export class UserAnswerSendingError extends ApiError {
  constructor(...args: ConstructorParameters<typeof ApiError>) {
    super(...args);
  }
}

export const sendUserAnswer = async (answer: UserAnswerToSend) => {
  try {
    const data = await xfetch<BaseResponseData>(`${getApiBase()}/saveForm`, {
      timeout: REQUEST_TIMEOUT,
      data: answer
    });

    if (!data.success) {
      throw new ResponseSuccessFieldError();
    }

    return data;
  } catch (err) {
    throw new UserAnswerSendingError(undefined, { cause: err });
  }
};
